<template>
  <div class="site-title">
    <a href="/" title="GridUnity Interconnection Portal" aria-label="GridUnity Interconnection Portal">
      <SiteLogo />
    </a>
    <h1 class="text-primary">Interconnection Portal</h1>
  </div>
</template>

<script setup>
import SiteLogo from './SiteLogo.vue'
</script>
